import { gql } from '@apollo/client';

export const EDIT_SURROUNDING_INFORMATION_PROPERTY_MUTATION = gql`
  fragment CommonSurroundingInformationPropertyEdit on SurroundingInformationProperty {
    id
    icon
    text
    badgeColor
    locale
    surroundingInformation {
      id
    }
    appSortOrder
  }

  mutation EditSurroundingInformationProperty(
    $id: ID!
    $data: editSurroundingInformationPropertyInput!
  ) {
    updateSurroundingInformationProperty(input: { where: { id: $id }, data: $data }) {
      surroundingInformationProperty {
        ...CommonSurroundingInformationPropertyEdit
      }
    }
  }
`;
